<section class="form-wrapper">
  <mat-card appearance="outlined" class="form-wrapper__settings">
    <mat-card-header>
      <mat-card-title>
        Controller attributes
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="container" novalidate>
        @if (!showControllerForm) {
          <mat-progress-spinner mode="indeterminate" [diameter]=20></mat-progress-spinner>
        }

        @if (showControllerForm) {
          <form [formGroup]="controllerForm" data-testid="form" (ngSubmit)="onSave()"
            class="form">
            <details class="controller-attribute-section" open>
              <summary>General</summary>
              <div class="controller-attribute-group">
                <mat-form-field class="form-element">
                  <mat-label>Name [name]</mat-label>
                  <input matInput placeholder="Name" data-testid="name" formControlName="name">
                  @if (controllerForm.get('name').hasError('required')) {
                    <mat-error>The field name is required</mat-error>
                  }
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Description [description]</mat-label>
                  <input matInput type="text" placeholder="Description" data-testid="description" formControlName="description">
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Item [item]</mat-label>
                  <input matInput type="text" placeholder="Item" data-testid="item" formControlName="item">
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Net Weight [net_weight]</mat-label>
                  <input matInput type="number" placeholder="Net Weight" data-testid="net_weight"
                    formControlName="net_weight">
                  <span matSuffix>kg</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Gross weight [gross_weight]</mat-label>
                  <input matInput type="number" placeholder="Gross weight" data-testid="gross_weight" formControlName="gross_weight">
                  <span matSuffix>kg</span>
                </mat-form-field>
                <app-packaging-select fieldName="packaging" data-testid="packaging" formControlName="packaging"></app-packaging-select>
                <mat-form-field class="form-element">
                  <mat-label>min temp [min_temp]</mat-label>
                  <input matInput type="number" placeholder="min temp" data-testid="min_temp" formControlName="min_temp">
                  <span matSuffix>°C</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>max temp [max_temp]</mat-label>
                  <input matInput type="number" placeholder="max temp" data-testid="max_temp" formControlName="max_temp">
                  <span matSuffix>°C</span>
                </mat-form-field>
                <app-enclosure-class-select-new fieldName="ingress_protection_code" data-testid="ingress_protection_code"
                formControlName="ingress_protection_code"></app-enclosure-class-select-new>
                <mat-form-field class="form-element">
                  <mat-label>efficiency [efficiency]</mat-label>
                  <input matInput type="number" placeholder="efficiency" data-testid="efficiency"
                    formControlName="efficiency">
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Min Cable Size [min_cable_size]</mat-label>
                  <input matInput type="number" placeholder="Min Cable Size" data-testid="min_cable_size"
                    formControlName="min_cable_size">
                  <span matSuffix>m&#x33A1;</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>economical_value_for_sort_order [economical_value_for_sort_order]</mat-label>
                  <input matInput type="number" placeholder="economical_value_for_sort_order"
                    data-testid="economical_value_for_sort_order" formControlName="economical_value_for_sort_order">
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>U Factor [u_factor]</mat-label>
                  <input matInput type="number" placeholder="U Factor" data-testid="u_factor" formControlName="u_factor">
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>I Factor [i_factor]</mat-label>
                  <input matInput type="number" placeholder="I Factor" data-testid="i_factor" formControlName="i_factor">
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>I Offset [i_offset]</mat-label>
                  <input matInput type="number" placeholder="I Offset" data-testid="i_offset" formControlName="i_offset">
                </mat-form-field>
                @for (field of additionalFields['general']; track field.name) {
                  <mat-form-field class="form-element">
                    <mat-label>{{ field.label }} [{{ field.name }}]</mat-label>
                    @if (field.type === 'number') {
                      <input matInput type="number" [attr.data-testid]="field.name" [formControlName]="field.name">
                    } @else {
                      <input matInput type="text" [attr.data-testid]="field.name" [formControlName]="field.name">
                    }
                    @if (field.unit) { <span matSuffix>{{ field.unit }}</span> }
                  </mat-form-field>
                }
              </div>
            </details>
            <details class="controller-attribute-section">
              <summary>Dimensions</summary>
              <div class="controller-attribute-group">
                <mat-form-field class="form-element">
                  <mat-label>h [h]</mat-label>
                  <input matInput type="number" placeholder="h" data-testid="h" formControlName="h">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>h1 [h1]</mat-label>
                  <input matInput type="number" placeholder="h1" data-testid="h1" formControlName="h1">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>h2 [h2]</mat-label>
                  <input matInput type="number" placeholder="h2" data-testid="h2" formControlName="h2">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>h3 [h3]</mat-label>
                  <input matInput type="number" placeholder="h3" data-testid="h3" formControlName="h3">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>w [w]</mat-label>
                  <input matInput type="number" placeholder="w" data-testid="w" formControlName="w">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>w1 [w1]</mat-label>
                  <input matInput type="number" placeholder="w1" data-testid="w1" formControlName="w1">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>w2 [w2]</mat-label>
                  <input matInput type="number" placeholder="w2" data-testid="w2" formControlName="w2">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>w3 [w3]</mat-label>
                  <input matInput type="number" placeholder="w3" data-testid="w3" formControlName="w3">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>d [d]</mat-label>
                  <input matInput type="number" placeholder="d" data-testid="d" formControlName="d">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>d1 [d1]</mat-label>
                  <input matInput type="number" placeholder="d1" data-testid="d1" formControlName="d1">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>d2 [d2]</mat-label>
                  <input matInput type="number" placeholder="d2" data-testid="d2" formControlName="d2">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>e [e]</mat-label>
                  <input matInput type="number" placeholder="e" data-testid="e" formControlName="e">
                  <span matSuffix>mm</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>e1_dim [e1]</mat-label>
                  <input matInput type="number" placeholder="e1_dim" data-testid="e1" formControlName="e1">
                  <span matSuffix>mm</span>
                </mat-form-field>
              </div>
            </details>
            <details class="controller-attribute-section">
              <summary>Diagrams</summary>
              <div class="controller-attribute-group">
                <app-drawing-view fieldName="drawing" class="form-wrapper__view-wrapper" data-testid="drawing" formControlName="drawing"
                  (urlChange)="onDrawingSelect($event)">
                </app-drawing-view>
                <app-picture-select-new fieldName="picture" class="form-wrapper__picture-wrapper" formControlName="picture"
                  (urlChange)="onPictureSelect($event)">
                </app-picture-select-new>
              </div>
            </details>
            <details class="controller-attribute-section">
              <summary>Input AC</summary>
              <div class="controller-attribute-group">
                <mat-form-field class="form-element">
                  <mat-label>Operating voltage [op_voc]</mat-label>
                  <input matInput type="text" placeholder="Operating voltage" data-testid="op_voc" formControlName="op_voc">
                  <span matSuffix>V</span>
                </mat-form-field>
                @for (field of additionalFields['inputAc']; track field.name) {
                  <mat-form-field class="form-element">
                    <mat-label>{{ field.label }} [{{ field.name }}]</mat-label>
                    @if (field.type === 'number') {
                      <input matInput type="number" [attr.data-testid]="field.name" [formControlName]="field.name">
                    } @else {
                      <input matInput type="text" [attr.data-testid]="field.name" [formControlName]="field.name">
                    }
                    @if (field.unit) { <span matSuffix>{{ field.unit }}</span> }
                  </mat-form-field>
                }
              </div>
            </details>
            <details class="controller-attribute-section">
              <summary>Input DC</summary>
              <div class="controller-attribute-group">
                <mat-form-field class="form-element">
                  <mat-label>Max Voc [max_voc]</mat-label>
                  <input matInput type="number" placeholder="Max Voc" data-testid="max_voc" formControlName="max_voc">
                  <span matSuffix>V</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Max I [max_i]</mat-label>
                  <input matInput type="number" placeholder="Max I" data-testid="max_i" formControlName="max_i">
                  <span matSuffix>A</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Max P [max_p]</mat-label>
                  <input matInput type="number" placeholder="Max P" data-testid="max_p" formControlName="max_p">
                  <span matSuffix>W</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Max PV short circuit current [max_isc]</mat-label>
                  <input matInput type="number" placeholder="Max PV short circuit current" data-testid="max_isc" formControlName="max_isc">
                  <span matSuffix>A</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Min recommended Vmp (MPPT) [min_vmp]</mat-label>
                  <input matInput type="number" placeholder="Min recommended Vmp" data-testid="min_vmp" formControlName="min_vmp">
                  <span matSuffix>V</span>
                </mat-form-field>
                @for (field of additionalFields['inputDc']; track field.name) {
                  <mat-form-field class="form-element">
                    <mat-label>{{ field.label }} [{{ field.name }}]</mat-label>
                    @if (field.type === 'number') {
                      <input matInput type="number" [attr.data-testid]="field.name" [formControlName]="field.name">
                    } @else {
                      <input matInput type="text" [attr.data-testid]="field.name" [formControlName]="field.name">
                    }
                    @if (field.unit) { <span matSuffix>{{ field.unit }}</span> }
                  </mat-form-field>
                }
              </div>
            </details>
            <details class="controller-attribute-section">
              <summary>Output AC</summary>
              <div class="controller-attribute-group">
                <mat-form-field class="form-element">
                  <mat-label>Rated voltage [output_rated_voc]</mat-label>
                  <input matInput type="number" placeholder="Rated voltage" data-testid="output_rated_voc" formControlName="output_rated_voc">
                  <span matSuffix>V</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Max. Output Voltage [max_output_voc]</mat-label>
                  <input matInput type="text" placeholder="Max. Output Voltage" data-testid="max_output_voc" formControlName="max_output_voc">
                  <span matSuffix>V</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Max Output Current [max_output_i]</mat-label>
                  <input matInput type="number" placeholder="Max Output Current" data-testid="max_output_i" formControlName="max_output_i">
                  <span matSuffix>A</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Max continuous power [max_output_p]</mat-label>
                  <input matInput type="number" placeholder="Max continuous power" data-testid="max_output_p" formControlName="max_output_p">
                  <span matSuffix>W</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Max frequency [max_freq]</mat-label>
                  <input matInput type="number" placeholder="Max frequency" data-testid="max_freq" formControlName="max_freq">
                  <span matSuffix>Hz</span>
                </mat-form-field>
                <mat-form-field class="form-element">
                  <mat-label>Frequency range [freq_range]</mat-label>
                  <input matInput type="text" placeholder="Frequency range" data-testid="freq_range" formControlName="freq_range">
                </mat-form-field>
                @for (field of additionalFields['outputAc']; track field.name) {
                  <mat-form-field class="form-element">
                    <mat-label>{{ field.label }} [{{ field.name }}]</mat-label>
                    @if (field.type === 'number') {
                      <input matInput type="number" [attr.data-testid]="field.name" [formControlName]="field.name">
                    } @else {
                      <input matInput type="text" [attr.data-testid]="field.name" [formControlName]="field.name">
                    }
                    @if (field.unit) { <span matSuffix>{{ field.unit }}</span> }
                  </mat-form-field>
                }
              </div>
            </details>
<div class="form-element">
              <button mat-raised-button color="primary" [disabled]="!isDirty" data-testid="submit" type="submit"
              class="button">Save Form</button>
            </div>
          </form>
        }

        <div class="occupied"> place occupy </div>

      </div>
    </mat-card-content>

  </mat-card>

</section>